// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const CampaignSearchPage = () => import('@/modules/campaign/views/CampaignSearchPage')
const CampaignLeadPage = () => import('@/modules/campaign/views/CampaignLeadPage')
const CampaignDashboard  = () => import('@/modules/campaign/views/CampaignDashboard')
const CampaignNewLeadsList  = () => import('@/modules/campaign/views/CampaignNewLeadsList')
const CampaignAssignedLeadsList  = () => import('@/modules/campaign/views/CampaignAssignedLeadsList')
const CampaignCloserAssignedLeadsList  = () => import('@/modules/campaign/views/CampaignCloserAssignedLeadsList')
const CampaignPreviouslyInterestedList  = () => import('@/modules/campaign/views/CampaignPreviouslyInterestedList')
const CampaignList  = () => import('@/modules/campaign/views/CampaignList')
const CampaignBadLeadsList  = () => import('@/modules/campaign/views/CampaignBadLeadsList')
const CampaignMassAssignOpener  = () => import('@/modules/campaign/views/CampaignMassAssignOpener')
const CampaignMassAssignCloser  = () => import('@/modules/campaign/views/CampaignMassAssignCloser')

var routes = [
	{
	  path: '/campaign',
	  redirect: '/campaign/search',
	  name: 'Campaigns',
	  component: DefaultContainer,
	  children: [
		{
		  path: 'search',
		  name: 'CampaignSearchPage',
		  component: CampaignSearchPage,
		},
		{
		  path: 'company/:companyId/leads',
		  component: CampaignLeadPage,
		  redirect: 'dashboard',
		  redirect: '/campaign/company/:companyId/leads/dashboard',
		  meta: {
				requiresAuth: true,
				permission: false,
		  },
		  children: [
			{
			  path: 'dashboard',
			  name: 'CampaignDashboard',
			  component: CampaignDashboard,
			  meta: {
					requiresAuth: true,
					permission: false,
					tab: 'dashboard'
			  },
			},
			{
			  path: 'opener-assigned',
			  name: 'CampaignAssignedLeadsList',
			  component: CampaignAssignedLeadsList,
			  meta: {
					requiresAuth: true,
					permission: false,
					tab: 'opener-assigned',
					role_filter: 'opener',
			  },
			},
			{
				path: 'closer-assigned',
				name: 'CampaignCloserAssignedLeadsList',
				component: CampaignCloserAssignedLeadsList,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'closer-assigned',
					role_filter: 'closer',
				},
			},
			{
				path: 'new',
				name: 'CampaignNewLeadsList',
				component: CampaignNewLeadsList,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'new'
				},
			},
			{
				path: 'previously-interested',
				name: 'CampaignPreviouslyInterestedList',
				component: CampaignPreviouslyInterestedList,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'previously-interested'
				},
			},
			{
				path: 'bad',
				name: 'CampaignBadLeadsList',
				component: CampaignBadLeadsList,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'bad'
				},
			},
			{
				path: 'list',
				name: 'CampaignList',
				component: CampaignList,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'campaign-list'
				},
			},
			{
				path: 'bulk-assign-opener',
				name: 'CampaignMassAssignOpener',
				component: CampaignMassAssignOpener,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'bulk-assign-opener'
				},
			},
			{
				path: 'bulk-assign-closer',
				name: 'CampaignMassAssignCloser',
				component: CampaignMassAssignCloser,
				meta: {
					requiresAuth: true,
					permission: false,
					tab: 'bulk-assign-closer'
				},
			},
		  ]
		}
	  ]
	}
  ];

export default routes;
